<section>
    <h1>Hittade inte sidan (404)</h1>
    <p>Sidan du letar efter finns inte. Du kan försöka <a [routerLink]="['/']">ta dig till startsidan</a></p>
</section>